import React, { useState, useEffect } from "react";
import { Button, Form as FormReactstrap, FormGroup, Label, Input } from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-bootstrap";
import Swal, { swalError, confirmSwal } from "../../../swal";
import { sendData, getData } from "../../../../helpers/auth";
import { getAcls } from "../../../../helpers/acls";
import { Aguarde, width } from "../../../../helpers/general";
import { uriList } from "../../../../helpers/config";
import { connect } from "react-redux";
import { tiposUsuario } from "../../../../helpers/consts";
import MultiSelect from "../../../layout/MultiSelect";


// Função utilitária para ordenar por group e depois por label
function sortByGroupAndLabel(arr) {
    if (!arr) return [];
    return arr.slice().sort((a, b) => {
        const groupA = (a.group || "").toLowerCase();
        const groupB = (b.group || "").toLowerCase();
        if (groupA < groupB) return -1;
        if (groupA > groupB) return 1;
        // Se o grupo for igual, ordena por label
        const labelA = (a.label || "").toLowerCase();
        const labelB = (b.label || "").toLowerCase();
        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0;
    });
}

// Função utilitária para normalizar strings (igual a do acls.js)
function normalizePermissao(str) {
    if (!str) return '';
    return str
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // remove acentos
        .replace(/[^a-zA-Z0-9]/g, '')   // remove caracteres especiais
        .toLowerCase();
}

// Função para inicializar o grupo com status = 'ATIVO' se não vier do props
function getInitialGrupo(propsGrupo) {
    let grupo = propsGrupo || {};
    // Se não tem status, define como 'ATIVO'
    if (!grupo.status) {
        grupo = { ...grupo, status: 'ATIVO' };
    }
    return grupo;
}

const Form = ({ ...props }) => {
    const [grupo, setGrupo] = useState(getInitialGrupo(props.grupo));
    const [gravando, setGravando] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [multSelect, setMultSelect] = useState(true);
    const [permissoes, setPermissoes] = useState(null);
    const [permissoesFiltradas, setPermissoesFiltradas] = useState(null);
    const [clickedTr, setClickedTr] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [carregando, setCarregando] = useState(true);
    const [empresas, setEmpresas] = useState([]);
    const [empresas_, setEmpresas_] = useState([]);

    // NOVO: Estado para filtro de marcadas
    const [filtroMarcadas, setFiltroMarcadas] = useState(false);

    // Para saber se houve alteração nas permissões (checked) desde o carregamento
    const [permissoesOriginais, setPermissoesOriginais] = useState([]);
    // Removido nomeInputRef e searchInputRef

    useEffect(() => {
        console.log("gruposacl.useEffect: ", props.grupo);
        carregarPermissoes();
        _getEmpresas();
        // eslint-disable-next-line
    }, []);

    // useEffect para filtrar permissoesFiltradas conforme searchTerm, permissoes e filtroMarcadas, ordenando por group e label
    useEffect(() => {
        if (permissoes) {
            const term = (searchTerm || "").toLowerCase();
            let filtered = permissoes.filter(permissao =>
                (permissao.description || "").toLowerCase().includes(term) ||
                (permissao.name || "").toLowerCase().includes(term) ||
                (permissao.label || "").toLowerCase().includes(term) ||
                (permissao.group || "").toLowerCase().includes(term)
            );
            if (filtroMarcadas) {
                filtered = filtered.filter(p => p.checked);
            }
            setPermissoesFiltradas(sortByGroupAndLabel(filtered));
            setCarregando(false);
        }
    }, [searchTerm, permissoes, filtroMarcadas]);

    const _getEmpresas = () => {
        getData({ uri: uriList("empresas") })
            .then((res) => {
                if (res.status && res.status > 200) throw new Error();

                setEmpresas(res);
            })
            .catch((e) => {
                return false;
            });
    }

    // Corrigido: método não deve gravar, apenas buscar permissões do grupo (GET)
    async function carregarPermissoes() {
        console.log("gruposacl.carregarPermissoes", grupo);
        setCarregando(true);

        // 1. Carrega todas as permissões possíveis do arquivo acls.js
        let todasPermissoes = getAcls();
        if (!todasPermissoes) {
            swalError({ title: "Erro ao buscar permissões", text: "Não foi possível carregar as permissões" });
            setCarregando(false);
            return;
        }

        // 2. Busca as permissões já preenchidas para o grupo
        // Corrigido: usar método GET e passar id do grupo (se houver)
        let uri = uriList("buscarGrupoPermissoes");
        let content = {};
        if (grupo && grupo.id) {
            content = { id: grupo.id };
        }

        try {
            // Se não tem id, não busca do backend, apenas mostra todas desmarcadas
            let permissoesGrupo = [];
            if (content.id) {
                const res = await sendData({ uri, content, method: "POST" });
                if (res.status === 200) {
                    permissoesGrupo = res.data?.permissoes?.acls || [];
                    setEmpresas_(res.data?.empresas || []);
                } else {
                    swalError({ title: "Erro ao buscar permissões do grupo", text: res._status });
                }
            }
            // Cria um Set com as permissões já preenchidas, normalizando name e action
            const permissoesPreenchidas = new Set();
            permissoesGrupo.forEach(p => {
                if (p.name) permissoesPreenchidas.add(normalizePermissao(p.name));
                if (p.action) permissoesPreenchidas.add(normalizePermissao(p.action));
            });
            // Marca como checked as permissões que o grupo já possui (comparando normalizado)
            const permissoesComChecked = todasPermissoes.map(p => {
                const nameNorm = normalizePermissao(p.name);
                const actionNorm = normalizePermissao(p.action);
                const checked = permissoesPreenchidas.has(nameNorm) || permissoesPreenchidas.has(actionNorm);
                return {
                    ...p,
                    checked
                };
            });
            setPermissoes(permissoesComChecked);
            // Não seta permissoesFiltradas aqui, pois será feito pelo useEffect de searchTerm/permissoes
            setPermissoesOriginais(permissoesComChecked.map(p => !!p.checked));
        } catch (e) {
            console.log("gruposPermissoes.carregarPermissoes(error)", e);
            swalError({ title: "Erro ao buscar permissões do grupo", text: e?.message || "Erro desconhecido" });
            // Em caso de erro, mostra todas as permissões desmarcadas
            const permissoesComChecked = todasPermissoes.map(p => ({
                ...p,
                checked: false
            }));
            setPermissoes(permissoesComChecked);
            setPermissoesOriginais(permissoesComChecked.map(p => false));
        }

        setCarregando(false);
    }

    async function handlePost() {
        async function callback(e) {
            if (!e)
                return;
            let uri = grupo.id ? uriList("gravarGrupoPermissoesUpdate") : uriList("gravarGrupoPermissoes");
            let _permissoes = permissoes.filter((permissao) => permissao.checked);
            let content = {
                id: grupo.id,
                nome: grupo.nome,
                tipo_usuario: (grupo.tipo_usuario && grupo.tipo_usuario.toLowerCase() === "todos") ? null : (grupo.tipo_usuario || null),
                status: grupo.status,
                permissoes: {
                    acls: _permissoes
                },
                empresas: empresas_
            };
            setGravando(true);
            return await sendData({ uri, content, method: "POST" })
                .then((res) => {
                    if (res._status == 200) {
                        // Atualiza o snapshot das permissões originais após gravar
                        setPermissoesOriginais(permissoes.map(p => !!p.checked));
                        handleClose(true); // true = gravou
                    } else {
                        swalError({ title: "Erro ao gravar permissões do grupo", text: res.message });
                    }
                    setGravando(false);
                })
                .catch((e) => {
                    console.log("gruposPermissoes.handlePost(error)");
                    console.log(e)
                    setGravando(false);
                });
        }

        confirmSwal({ title: "Confirma a gravação das permissões?", text: "", callback });
    }

    // Função para verificar se houve alteração nas permissões marcadas
    function houveAlteracaoPermissoes() {
        if (!permissoes || permissoes.length === 0) return false;
        if (!permissoesOriginais || permissoesOriginais.length !== permissoes.length) return true;
        for (let i = 0; i < permissoes.length; i++) {
            if (!!permissoes[i].checked !== !!permissoesOriginais[i]) {
                return true;
            }
        }
        return false;
    }

    // handleClose agora verifica se há alterações não gravadas
    function handleClose(gravou = false) {
        // Se já gravou, pode fechar direto
        if (gravou) {
            if (props.onCloseEv)
                props.onCloseEv();
            return;
        }
        // Se não houve alteração, pode fechar direto
        if (!houveAlteracaoPermissoes()) {
            if (props.onCloseEv)
                props.onCloseEv();
            return;
        }
        // Se houve alteração, pergunta ao usuário
        confirmSwal({
            title: "Permissões não salvas",
            text: "Existem permissões marcadas/desmarcadas que não foram gravadas. Deseja fechar mesmo assim?",
            callback: (ok) => {
                if (ok) {
                    if (props.onCloseEv)
                        props.onCloseEv();
                }
            }
        });
    }

    // REESCRITO: Marcar todos apenas os registros filtrados
    const handleSelectAll = () => {
        // O valor de "marcar todos" é se todos os filtrados estão marcados
        const allChecked = permissoesFiltradas && permissoesFiltradas.length > 0 && permissoesFiltradas.every(p => p.checked);
        setSelectAll(!allChecked);

        // Cria um Set com os nomes das permissões filtradas para fácil lookup
        const nomesFiltrados = new Set((permissoesFiltradas || []).map(p => p.name));

        // Atualiza apenas as permissões filtradas
        let _permissoes = permissoes.map((permissao) => {
            if (nomesFiltrados.has(permissao.name)) {
                return {
                    ...permissao,
                    checked: !allChecked
                };
            } else {
                return permissao;
            }
        });
        setPermissoes(_permissoes);
    }

    const handlePermissao = (permissao) => {
        let _permissoes = permissoes.map((_permissao) => ({
            ..._permissao,
            checked: _permissao.name === permissao.name ? !_permissao.checked : _permissao.checked
        }));

        setPermissoes(_permissoes);
        setClickedTr(permissao);
    }

    // Largura da coluna do checkbox (em px)
    const checkboxColWidth = 35;

    // NOVO: Largura das colunas para 4 colunas: checkbox, permissão, descrição, grupo
    // checkbox: 35px, permissão: 25%, descrição: 60%, grupo: 20%
    const permissaoColWidth = "30%";
    const descricaoColWidth = "65%";
    // const grupoColWidth = "20%";

    // Padding padrão para todas as células (2px da margem da coluna)
    const cellPadding = "3px";

    // CSS para colunas fixas
    const fixedColStyles = {
        position: "sticky",
        left: 0,
        background: "#fff",
        zIndex: 3,
        borderRight: "1px solid #dee2e6",
        borderBottom: "1px solid #dee2e6",
        borderTop: "1px solid #dee2e6",
        borderLeft: "1px solid #dee2e6",
        fontSize: "14px", // aumentada
        padding: cellPadding,
        verticalAlign: "middle",
        width: checkboxColWidth
    };

    // Para sticky, precisamos calcular o left das colunas
    const fixedCol2Styles = {
        position: "sticky",
        left: checkboxColWidth,
        background: "#fff",
        zIndex: 3,
        borderRight: "1px solid #dee2e6",
        borderBottom: "1px solid #dee2e6",
        borderTop: "1px solid #dee2e6",
        fontSize: "14px", // aumentada
        padding: cellPadding,
        verticalAlign: "middle",
        width: permissaoColWidth,
        minWidth: 0,
        maxWidth: "none",
        boxSizing: "border-box"
    };
    const fixedCol3Styles = {
        position: "sticky",
        left: `calc(${checkboxColWidth}px + ${permissaoColWidth})`,
        background: "#fff",
        zIndex: 2,
        borderBottom: "1px solid #dee2e6",
        borderTop: "1px solid #dee2e6",
        fontSize: "14px", // aumentada
        padding: cellPadding,
        verticalAlign: "middle",
        width: descricaoColWidth,
        minWidth: 0,
        maxWidth: "none",
        boxSizing: "border-box"
    };
    // NOVO: Coluna grupo (não sticky)
    const grupoColStyles = {
        background: "#fff",
        zIndex: 1,
        borderBottom: "1px solid #dee2e6",
        borderTop: "1px solid #dee2e6",
        fontSize: "14px",
        padding: cellPadding,
        verticalAlign: "middle",
        // width: grupoColWidth,
        minWidth: 0,
        maxWidth: "none",
        boxSizing: "border-box",
        wordWrap: "break-word",
        whiteSpace: "normal"
    };
    // CSS para fixar o cabeçalho da tabela
    const theadStickyStyle = {
        position: "sticky",
        top: 0,
        zIndex: 4,
        background: "#fff",
        borderTop: "1px solid #dee2e6",
        borderBottom: "2px solid #dee2e6"
    };

    // CSS para th do cabeçalho (para garantir bordas)
    const thHeaderStyle = {
        border: "1px solid #dee2e6",
        background: "#fff",
        zIndex: 4,
        fontSize: "14px", // aumentada
        padding: cellPadding,
        height: "28px", // voltou para 28
        verticalAlign: "middle"
    };

    // CSS para as células da tabela (td)
    const tdStyle = {
        fontSize: "14px", // aumentada
        padding: cellPadding,
        height: "28px", // altura fixa da linha
        minHeight: "28px",
        // maxHeight: "28px", // REMOVIDO: Permite que o conteúdo quebre linha e a célula se expanda
        verticalAlign: "middle"
    };

    // CSS para a div externa da tabela
    const outerTableDivStyle = {
        border: "0.5px solid #bdbdbd",
        margin: 0,
        padding: 0,
        width: "100%",
        background: "#dee2e6", // cinza bem clarinho, igual à cor da borda da tabela
        minHeight: 400,
        maxHeight: 400,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        maxHeight: `calc(25vh)`, // Limita a altura máxima da tabela de permissões
        minHeight: `calc(25vh)`,
        overflow: "hidden"
    };

    // CSS para o rodapé do cabeçalho (abaixo do input de pesquisa)
    const headerFooterStyle = {
        borderBottom: "1px solid #dee2e6",
        marginBottom: 0,
        paddingBottom: 0
    };

    // CSS para o botão de limpar (X) do input de pesquisa
    const clearButtonStyle = {
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: "16px",
        color: "#888",
        padding: 0,
        zIndex: 10,
        lineHeight: 1
    };

    // --- NOVO: Cálculo dos totais para o rodapé da tabela ---
    const total = permissoesFiltradas ? permissoesFiltradas.length : 0;
    const marcadas = permissoesFiltradas ? permissoesFiltradas.filter(p => p.checked).length : 0;
    const desmarcadas = permissoesFiltradas ? permissoesFiltradas.filter(p => !p.checked).length : 0;

    // CSS para o rodapé fora da tabela, colunas alinhadas à esquerda
    const footerSummaryStyle = {
        display: "flex",
        width: "100%",
        background: "#f8f9fa",
        fontWeight: "bold",
        fontSize: "13px",
        borderTop: "2px solid #dee2e6",
        borderBottom: "1px solid #dee2e6",
        margin: 0,
        padding: 0,
        minHeight: "36px"
    };
    const footerSummaryColStyle = {
        flex: 1,
        textAlign: "left",
        padding: "8px 6px",
        borderRight: "1px solid #dee2e6",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start"
    };
    const footerSummaryColLastStyle = {
        ...footerSummaryColStyle,
        borderRight: "none"
    };

    // Função para forçar apenas letras maiúsculas no nome do grupo
    const handleNomeChange = (e) => {
        const upper = (e.target.value || '').toUpperCase();
        setGrupo({ ...grupo, nome: upper });
    };

    // Função para tratar o status (apenas 'ATIVO' ou 'INATIVO')
    const handleStatusChange = (e) => {
        const value = e.target.value;
        setGrupo({ ...grupo, status: value });
    };

    const handleTipoUsuarioChange = (e) => {
        const value = e.target.value;
        setGrupo({ ...grupo, tipo_usuario: value });
    };

    // NOVO: Handler para filtro de marcadas
    const handleFiltroMarcadas = (e) => {
        setFiltroMarcadas(e.target.checked);
    };

    // Renderiza a tela em Modal
    return (
        <Modal
            show={props.show !== undefined ? props.show : true}
            onHide={() => handleClose(false)}
            size="lg"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Cadastro de Grupos de Permissões</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormReactstrap>
                    <FormGroup>
                        <Label for="nome">Nome do Grupo</Label>
                        <Input
                            type="text"
                            name="nome"
                            id="nome"
                            value={grupo.nome || ''}
                            autoFocus={true}
                            // innerRef removido
                            onChange={handleNomeChange}
                        />
                    </FormGroup>
                    <FormGroup className="row">
                        <div className="col-md-6">
                            <Label for="status">Status</Label>
                            <Input
                                type="select"
                                name="status"
                                id="status"
                                value={grupo.status || 'ATIVO'}
                                onChange={handleStatusChange}
                            >
                                <option value="ATIVO">ATIVO</option>
                                <option value="INATIVO">INATIVO</option>
                            </Input>
                        </div>
                        <div className="col-md-6">
                            <Label for="tipo">Tipo de Usuário</Label>
                            <Input
                                type="select"
                                name="tipo"
                                id="tipo"
                                value={grupo.tipo_usuario || ''}
                                onChange={handleTipoUsuarioChange}
                            >
                                <option value="">Todos</option>
                                {tiposUsuario &&
                                    tiposUsuario.map((item, key) => (
                                        <option key={key} value={item.id}>
                                            {item.nome}
                                        </option>
                                    ))}
                            </Input>
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <div className="row">
                            <MultiSelect
                                data={empresas}
                                selected={empresas_}
                                setSelected={setEmpresas_}
                                label="Empresas"
                                idField="id"
                                nameField="nome"
                                emptyText="Não existem empresas disponíveis"
                                visibleLines={2.5}
                                concatFields={["nome", "cnpj"]}
                            />
                        </div>
                    </FormGroup>

                    <div>
                        <div style={{ backgroundColor: "rgba(231, 230, 230,  0.18)" }}>
                            <div style={{ position: "sticky", top: 0, zIndex: 5, backgroundColor: "#fff", padding: "10px 0" }}>
                                {/* NOVO: Linha flex para input de pesquisa e checkbox filtro */}
                                <div style={{ display: "flex", width: "100%", alignItems: "center", gap: 8 }}>
                                    <div style={{ flex: "0 1 85%" }}>
                                        <div style={{ position: "relative", width: "100%" }}>
                                            <input
                                                type="text"
                                                placeholder="Pesquisar permissão"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    padding: "8px 32px 8px 8px", // espaço para o X
                                                    border: "1px solid #ddd",
                                                    borderRadius: "4px"
                                                }}
                                            />
                                            {searchTerm && (
                                                <button
                                                    type="button"
                                                    aria-label="Limpar pesquisa"
                                                    style={clearButtonStyle}
                                                    onClick={() => {
                                                        setSearchTerm('');
                                                    }}
                                                    tabIndex={0}
                                                >
                                                    &#10005;
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            flex: "0 1 auto",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                            paddingLeft: 2,
                                            minWidth: 0
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="filtroMarcadas"
                                            checked={filtroMarcadas}
                                            onChange={handleFiltroMarcadas}
                                            style={{ marginRight: 4 }}
                                        />
                                        <label
                                            htmlFor="filtroMarcadas"
                                            style={{
                                                margin: 0,
                                                fontSize: "12px",
                                                userSelect: "none",
                                                cursor: "pointer",
                                                minWidth: "auto",
                                                width: "auto",
                                                whiteSpace: "nowrap",
                                                padding: 0
                                            }}
                                        >
                                            Marcadas
                                        </label>
                                    </div>
                                </div>
                                <div style={headerFooterStyle}></div>
                            </div>
                            <div style={outerTableDivStyle}>
                                <div style={{
                                    flex: 1,
                                    overflowY: "auto",
                                    margin: 0,
                                    padding: 0
                                }}>
                                    {carregando ? (
                                        <div style={{ textAlign: "center", padding: 20, fontSize: "14px" }}>Carregando permissões...</div>
                                    ) : (
                                        <table className="table table-sm table-bordered"
                                            style={{
                                                background: "#fff",
                                                minWidth: 600,
                                                fontSize: "14px",
                                                margin: 0,
                                                tableLayout: "fixed",
                                                width: "100%"
                                            }}>
                                            {/* <colgroup>
                                                <col style={{ width: checkboxColWidth }} />
                                                <col style={{ width: permissaoColWidth }} />
                                                <col style={{ width: descricaoColWidth }} />
                                                <col style={{ width: grupoColWidth }} />
                                            </colgroup> */}
                                            <thead style={theadStickyStyle}>
                                                <tr>
                                                    <th style={{ ...thHeaderStyle, width: checkboxColWidth, ...fixedColStyles }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={permissoesFiltradas && permissoesFiltradas.length > 0 && permissoesFiltradas.every(p => p.checked)}
                                                            onChange={handleSelectAll}
                                                            title="Selecionar todas"
                                                            style={{ margin: 0 }}
                                                        />
                                                    </th>
                                                    <th style={{ ...thHeaderStyle, width: permissaoColWidth, ...fixedCol2Styles }}>Permissão</th>
                                                    <th style={{ ...thHeaderStyle, width: descricaoColWidth, ...fixedCol3Styles }}>Descrição</th>
                                                    {/* <th style={{ ...thHeaderStyle, width: grupoColWidth, ...grupoColStyles }}>Grupo</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {permissoesFiltradas && permissoesFiltradas.length > 0 ? (
                                                    permissoesFiltradas.map((permissao, idx) => (
                                                        <tr
                                                            key={permissao.name + idx}
                                                            style={{
                                                                background: clickedTr && clickedTr.name === permissao.name ? "#e6f7ff" : undefined,
                                                                cursor: "pointer",
                                                                height: "28px", // altura fixa da linha
                                                                minHeight: "28px",
                                                                // maxHeight: "28px" // REMOVIDO: Permite que o conteúdo quebre linha e a linha se expanda
                                                            }}
                                                            onClick={() => handlePermissao(permissao)}
                                                        >
                                                            <td style={{ ...fixedColStyles, ...tdStyle }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={!!permissao.checked}
                                                                    onChange={() => handlePermissao(permissao)}
                                                                    onClick={e => e.stopPropagation()}
                                                                    style={{ margin: 0 }}
                                                                />
                                                            </td>
                                                            <td style={{ ...fixedCol2Styles, ...tdStyle }}>{permissao.label || permissao.name}</td>
                                                            <td style={{ ...fixedCol3Styles, ...tdStyle }}>{permissao.description}</td>
                                                            {/* <td style={{ ...grupoColStyles, ...tdStyle }}>
                                                                {permissao.group || ""}
                                                            </td> */}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: "center", fontSize: "14px", padding: cellPadding, height: "28px", minHeight: "28px" /* maxHeight removido */ }}>Nenhuma permissão encontrada</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                {/* Rodapé fora da tabela, colunas alinhadas à esquerda */}
                                <div style={footerSummaryStyle}>
                                    <div style={footerSummaryColStyle}>
                                        Quantidade: <span style={{ fontWeight: "normal", marginLeft: 4 }}>{total}</span>
                                    </div>
                                    <div style={footerSummaryColStyle}>
                                        Marcadas: <span style={{ fontWeight: "normal", marginLeft: 4 }}>{marcadas}</span>
                                    </div>
                                    <div style={footerSummaryColLastStyle}>
                                        Desmarcadas: <span style={{ fontWeight: "normal", marginLeft: 4 }}>{desmarcadas}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FormReactstrap>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    color="success"
                    onClick={handlePost}
                    disabled={gravando}
                    style={{ fontSize: "13px", marginRight: "10px", width: "100px", minWidth: "100px", height: "38px", minHeight: "38px" }}
                >
                    Gravar
                </Button>
                <Button
                    color="secondary"
                    onClick={() => handleClose(false)}
                    disabled={gravando}
                    style={{ fontSize: "13px", width: "100px", minWidth: "100px", height: "38px", minHeight: "38px" }}
                >
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

function mapStateToProps(state) {
    return {
        user: state.dados.user,
    };
}

export default connect(mapStateToProps)(Form);
